import React, { useState } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { editSound } from 'flow/actions/sounds-actions';
import SettingSection from 'flow/components/Setting/SettingSection';
import BaseModal from 'flow/components/ui-components/BaseModal';
import BaseTextArea from 'flow/components/ui-components/BaseTextArea';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    soundKey?: string;
}

const EditSoundModal = ({ soundKey }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const sound = useAppSelector((state) =>
        state.sounds
            .get('sounds')
            .filter((sound) => sound.get('key') === soundKey)
            .first(),
    );

    const [name, setName] = useState(sound.get('name'));
    const [description, setDescription] = useState(sound.get('description'));

    const onSubmit = () => {
        const soundDTO = sound
            .update('name', () => name)
            .update('description', () => description);
        dispatch(editSound(soundDTO, soundKey));
    };

    return (
        <BaseModal
            open={true}
            header={i18next.t('settings.voicemail.edit_sound')}
            onSubmit={onSubmit}
            disableSubmit={!name}
        >
            <SettingSection>{i18next.t('input.title')}</SettingSection>

            <BaseTextArea
                id="title"
                value={name}
                onChange={(event) => setName(event.target.value)}
            />

            <SettingSection>{i18next.t('input.description')}</SettingSection>

            <BaseTextArea
                id="description"
                value={description}
                onChange={(event) => setDescription(event.target.value)}
                rows={6}
            />
        </BaseModal>
    );
};

export default EditSoundModal;
